import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import Loader from '@/components/Includes/Loader/Loader.vue';
import Pagination from '@/components/Includes/Pagination/Pagination.vue';
import TableEmpty from '@/components/Includes/Table/TableFooter/TableEmpty/TableEmpty.vue';
import IPayloadQuery from '@/interfaces/IPayloadQuery';
import IUserForm from '@/interfaces/users/IUserForm';
import IUserFormProps from '@/interfaces/users/IUserFormProps';
import searchByTable from '@/libs/searchQuery/searchByTable';

import DefaultTools from '@/components/Includes/DefaultTools/DefaultTools.vue';

@Component({
    name: 'UsersList',
    components: {
        DefaultTools,
        TableEmpty,
        Loader,
        Pagination
    }
})
export default class UserList extends Vue {
    @Action private usersList!: (query: IPayloadQuery) => number;
    @Getter private getUsers!: () => IUserForm[];

    private loading: boolean = false;

    private filtered: IUserFormProps[] | object[] | null = null;

    private columns: string[] = [
        'id', 
        'username', 
        'email', 
        'groups',
        'roles'
    ];

    private selectedLimit: string = '100';
    private totalUsers: number = 0;

    private get usersData() {
        return this.filtered ? this.filtered : this.users;
    }

    private get users() {
        return this.getUsers();
    }

    private get totalItems():number {
        return this.filtered ? this.filtered.length : this.totalUsers;
    }

    private get notEmpty() {
        return this.getUsers().length !== 0;
    }

    private get currentPage(): number {
        return +this.$route.query.page || 1;
    }

    private set currentPage(page: number) {
        const query = {...this.$route.query, page: `${page}`};

        this.$router.push({ query });
    }

    private get payloadQuery(): IPayloadQuery {
        return {
            query: `?pagination=true&page=${this.currentPage}&limit=${this.selectedLimit}`
        }
    }

    private userDetail(user: any) {
        this.$router.push({
            name: 'user_detail',
            params: { id: user.id, userData: user }
        });
    }

    private filterData(query: string) {
        this.filtered = searchByTable(query, this.users)
    }

    @Watch('selectedLimit')
    @Watch('currentPage')
    private onChangeFilterParams() {
        this.loadUsers();
    }

    private async loadUsers() {
        this.loading = true;
    
        this.totalUsers = await this.usersList(this.payloadQuery);

        this.loading = false;
    }

    private async mounted() {
        try {
            await this.loadUsers();
        } catch (error) {
            console.error(error);
        }
    }
}
